export default {
      id: "user-usage",
      viewBox: "0 0 23 23",
      url: "/" + "sprite.svg#user",
      toString: function () {
        return this.url;
      }
    }